import { _axios } from "@/plugins/axios";

const enterPresence = (request) => {
  return _axios.post("/attendance/presence/attend/enter", request);
};

const leavePresence = (request) => {
  return _axios.post("/attendance/presence/attend/leave", request);
};

const indexPresence = (request) => {
  return _axios.post(
    `/attendance/presence/list?page=${request.filter.page}&resPerPage=${request.filter.row}`,
    request.index
  );
};

const indexPresenceById = (request) => {
  return _axios.post(
    `/attendance/presence/user?page=${request.filter.page}&resPerPage=${request.filter.row}`,
    request.index
  );
};

const indexReason = () => {
  return _axios.get("/attendance/absent/getReasonList");
};

const indexStatus = () => {
  return _axios.get("/attendance/absent/getStatusList");
};

const indexDescription = () => {
  return _axios.get("/attendance/absent/getDescriptionList");
};

const indexAbsent = (request) => {
  return _axios.post(
    `/attendance/absent/list?page=${request.page}&resPerPage=${request.row}`,
    request
  );
};

const getPhotoAbsent = (absentId) => {
  return _axios.get(`attendance/absent/photo/${absentId}`);
};

const requestAbsent = (request) => {
  return _axios.post("/attendance/absent/request", request, {
    headers: {
      "content-type": "multipart/form-data",
    },
  });
};
const downloadRecap = (request) => {
  return _axios.post(`/attendance/utility/recap`, request, {
    responseType: "blob",
  });
};

const responseAbsent = (request) => {
  return _axios.post("/attendance/absent/respond", request);
};

const responseAbsentBatch = (request) => {
  return _axios.post("/attendance/absent/respond/batch", request);
};

const indexLocation = () => _axios.get("/attendance/presence/officeLocation");

export {
  enterPresence,
  leavePresence,
  indexPresence,
  indexReason,
  indexStatus,
  indexDescription,
  indexAbsent,
  requestAbsent,
  responseAbsent,
  getPhotoAbsent,
  downloadRecap,
  indexLocation,
  responseAbsentBatch,
  indexPresenceById
};
